import React from 'react';
import { motion } from 'framer-motion';
type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  id?: string;
  align?: 'center' | 'left';
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  id,
  align = 'center'
}: SectionHeadingProps) {
  const centered = align === 'center';
  return <motion.div initial={{
    opacity: 0,
    y: 14
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.5,
    ease: 'easeOut'
  }} className={centered ? 'text-center' : 'text-left'} data-id="element-118" data-mp="3k0oyr7dme0e3">
      {eyebrow && <p className="text-[11px] font-medium uppercase tracking-[0.4em] text-lotus-500" data-id="element-119" data-mp="1tsj3w9x6k0e">
          {eyebrow}
        </p>}
      <h2 id={id} className="mt-4 font-display text-4xl font-light tracking-wide text-white sm:text-5xl" data-id="element-120" data-mp="6rk9umytw030">
        {title}
      </h2>
      <div className={`rule-gold mt-6 w-24 ${centered ? 'mx-auto' : ''}`} data-id="element-121" data-mp="za7trz23992i" />
      {subtitle && <p className={`mt-6 text-[15px] font-light leading-relaxed text-neutral-400 ${centered ? 'mx-auto max-w-2xl' : 'max-w-2xl'}`} data-id="element-122" data-mp="1t95wh4lfa96o">
          {subtitle}
        </p>}
    </motion.div>;
}